import React, { useCallback, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";

import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import Close from "mdi-material-ui/Close";

import FormButtons from "views/components/formbuttons";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";

const Drawer = styled(MuiDrawer)(({ theme }) => ({
  width: 400,
  zIndex: theme.zIndex.modal,
  "& .MuiFormControlLabel-root": {
    marginRight: "0.6875rem",
  },
  "& .MuiDrawer-paper": {
    border: 0,
    width: 400,
    zIndex: theme.zIndex.modal,
    boxShadow: theme.shadows[9],
  },
}));

const UpdatePassword = (props) => {
  const { openResetPasswrd, handleResetPassword } = props;
  const [notMatchPswd, setNotMatchPswd] = useState(false);

  const defaultValues = {
    oldpassword: "",
    password: "",
    confirmPassword: "",
  };

  const {
    setValue,
    reset,
    setError,
    control,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues });

  const resetToEmptyValues = useCallback(() => {
    setValue("password", "");
    setValue("confirmPassword", "");
    setValue("oldpassword", "");
  }, [setValue]);

  const handleClose = () => {
    clearErrors();
    reset(defaultValues);
    handleResetPassword();
  };

  const onSubmit = (data) => {
    if (!data.password.match(data.confirmPassword)) {
      setError("confirmPassword", "password not match");
      setNotMatchPswd(true);
      return;
    }

    const payload = {
      oldPassword: data.oldpassword,
      newPassword: data.password,
    };

    APICall("post", payload, EndPoints.changePassword)
      .then((response) => {
        const { isError, message } = response.data;
        if (!isError) {
          toast.success(message);
          handleClose();
        } else {
          toast.error(message);
          return;
        }
      })
      .catch((error) => {
        return error;
      });
  };

  return (
    <div className="customizer">
      <Drawer
        open={openResetPasswrd}
        hideBackdrop
        anchor="right"
        variant="persistent"
      >
        <Box
          className="customizer-header"
          sx={{
            position: "relative",
            p: (theme) => theme.spacing(3.5, 5),
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, textTransform: "uppercase" }}
          >
            Change Password
          </Typography>
          <IconButton
            onClick={handleResetPassword}
            sx={{
              right: 20,
              top: "50%",
              position: "absolute",
              color: "text.secondary",
              transform: "translateY(-50%)",
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>
        <Box sx={{ p: 5 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name="oldpassword"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        onChange={onChange}
                        fullWidth
                        type="text"
                        label="Old Password"
                        placeholder="Enter old password"
                        error={Boolean(errors.oldpassword)}
                        aria-describedby="validation-basic-first-name"
                      />
                    )}
                  />
                  {errors.oldpassword && (
                    <FormHelperText
                      sx={{ color: "error.main" }}
                      id="validation-basic-first-name"
                    >
                      This field is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name="password"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        onChange={onChange}
                        fullWidth
                        type="text"
                        label="New Password"
                        placeholder="Enter new password"
                        error={Boolean(errors.password)}
                        aria-describedby="validation-basic-first-name"
                      />
                    )}
                  />
                  {errors.password && (
                    <FormHelperText
                      sx={{ color: "error.main" }}
                      id="validation-basic-first-name"
                    >
                      This field is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name="confirmPassword"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        onChange={onChange}
                        fullWidth
                        type="text"
                        label="Confirm New Password"
                        placeholder="Enter confirm new password"
                        error={Boolean(errors.confirmPassword)}
                        aria-describedby="validation-basic-first-name"
                      />
                    )}
                  />
                  {errors.confirmPassword && (
                    <FormHelperText
                      sx={{ color: "error.main" }}
                      id="validation-basic-first-name"
                    >
                      {notMatchPswd
                        ? "Password does not match"
                        : "This field is required"}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <FormButtons resetFunction={resetToEmptyValues} />
            </Grid>
          </form>
        </Box>
      </Drawer>
    </div>
  );
};

export default UpdatePassword;
